// extracted by mini-css-extract-plugin
export default {"intro":"ModalNuevoIngresoPago_intro__4zEHN","alert":"ModalNuevoIngresoPago_alert__UmfFs","input":"ModalNuevoIngresoPago_input__jN3tY"};